import { useTranslation } from "react-i18next";
import { useDeleteQuestionnaireRequestMutation } from "api/useQuestionnaireQueries";
import CustomModal from "components/lib/customModal";
import { Typography } from "components/typography";
import { Button, useSnackbar } from "@mindlercare/ui-web";
import { handleQuestionnaireError } from "api/questionnaireHelpers";
import { RowCenter } from "./modal.styles";

export const ConfirmQuestionnaireDeleteModal = ({
  setModalIsOpen,
  open,
  requestId,
  clinicalId,
  patientUserId,
}: {
  setModalIsOpen: (arg: boolean) => void;
  open: boolean;
  requestId?: string;
  patientUserId?: string;
  clinicalId?: string;
}) => {
  const { mutateAsync: deleteQuestionnaireRequest } =
    useDeleteQuestionnaireRequestMutation();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const handleCancel = () => {
    setModalIsOpen(false);
  };

  const handleDelete = async () => {
    if (!requestId || !patientUserId) return;

    try {
      await deleteQuestionnaireRequest({
        requestId,
        payload: {
          requestId,
          userId: patientUserId,
        },
      });
      enqueueSnackbar({
        text: `${clinicalId} ${t("DELETED")}.`,
        isError: false,
      });
    } catch (error) {
      handleQuestionnaireError(
        error,
        "NOT_PATIENT_DELETE_QUESTIONNAIRES_ERROR",
        enqueueSnackbar,
        t,
      );
    }

    setModalIsOpen(false);
  };

  return (
    <CustomModal.Wrapper
      onClose={() => setModalIsOpen(false)}
      open={open}
      size="small"
      isScrollable={true}
    >
      <div>
        <Typography insensitive variant="h3" style={{ textAlign: "center" }}>
          {t("DELETE_QUESTIONNAIRE_REQUEST_PROMPT")}
        </Typography>
        <RowCenter>
          <Button variant="secondary" onClick={handleCancel}>
            {t("CANCEL")}
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            {t("CONFIRM")}
          </Button>
        </RowCenter>
      </div>
    </CustomModal.Wrapper>
  );
};
